import { getParsedDateUntilToday } from 'utils/dateUtils'

import { PLAN_TYPES } from 'containers/App/constants'
import { selectActualLicenses } from 'containers/App/selectors'

import { STARTER_DATA } from './constants'

const selectData = (state) => {
  const planIsStarter = selectActualLicenses(state).plan === PLAN_TYPES.STARTER
  const starterData = {
    ...state.dashboard.threatProtection.flow.data,
    ...STARTER_DATA,
  }
  return planIsStarter ? starterData : state.dashboard.threatProtection.flow.data
}
const selectLoader = (state) => state.dashboard.threatProtection.flow.loader
const selectError = (state) => state.dashboard.threatProtection.flow.error

const selectMostTargetedEmployeesData = (state) =>
  state.dashboard.threatProtection.flow.mostTargetedEmployees.data
const selectMostTargetedEmployeesDataSecondPart = (state) =>
  state.dashboard.threatProtection.flow.mostTargetedEmployees.dataSecondPart
const selectMostTargetedEmployeesLoader = (state) =>
  state.dashboard.threatProtection.flow.mostTargetedEmployees.loader
const selectMostTargetedEmployeesError = (state) =>
  state.dashboard.threatProtection.flow.mostTargetedEmployees.error

const selectMitigationData = (state) => state.dashboard.threatProtection.flow.mitigation.data
const selectMitigationLoader = (state) => state.dashboard.threatProtection.flow.mitigation.loader
const selectMitigationError = (state) => state.dashboard.threatProtection.flow.mitigation.error

const selectMailboxAnomaly = (state) => {
  const planIsStarter = selectActualLicenses(state).plan === PLAN_TYPES.STARTER
  return planIsStarter
    ? STARTER_DATA.mailboxAnomaly
    : state.dashboard.threatProtection.flow.mailboxAnomaly.data
}
const selectMailboxAnomalyLoader = (state) =>
  state.dashboard.threatProtection.flow.mailboxAnomaly.loader
const selectMailboxAnomalyError = (state) =>
  state.dashboard.threatProtection.flow.mailboxAnomaly.error

const selectTopProfiles = (state) => state.dashboard.threatProtection.flow.topProfiles.data
const selectTopProfilesLoader = (state) => state.dashboard.threatProtection.flow.topProfiles.loader
const selectTopProfilesError = (state) => state.dashboard.threatProtection.flow.topProfiles.error

const selectDateFilter = (state) => state.dashboard.threatProtection.flow.dateFilter
const selectParsedDate = (state) => {
  const currentDateFilter = selectDateFilter(state)
  return getParsedDateUntilToday(currentDateFilter)
}

const selectAllFilters = (state) => state.dashboard.threatProtection.flow.allFilters
const selectAllFiltersLoader = (state) => state.dashboard.threatProtection.flow.allFiltersLoader

export {
  selectData,
  selectLoader,
  selectError,
  selectMostTargetedEmployeesData,
  selectMostTargetedEmployeesDataSecondPart,
  selectMostTargetedEmployeesLoader,
  selectMostTargetedEmployeesError,
  selectMitigationData,
  selectMitigationLoader,
  selectMitigationError,
  selectMailboxAnomaly,
  selectMailboxAnomalyLoader,
  selectMailboxAnomalyError,
  selectTopProfiles,
  selectTopProfilesLoader,
  selectTopProfilesError,
  selectDateFilter,
  selectAllFilters,
  selectAllFiltersLoader,
  selectParsedDate,
}
